import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectUserLogin = createSelector([(state: AppState) => state.shared.userLogin], ({ processing }) => ({ processing }));
